import { useFirebase } from 'components/Firebase/index.js';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import useClientPermissions from './useClientPermissions.js';

const sortOrganizations = (org, org2) => (org.title > org2.title ? 1 : -1);

const useClientOrganizations = ({ clientId, enabled = true, ...options } = {}) => {
  const firebase = useFirebase();
  const authUser = useSelector((state) => state.sessionState.authUser);
  const { clients } = useClientPermissions({ clientId });

  const isClientMember = !!clients[clientId];
  const hasAccess = isClientMember || authUser?.isSuperadmin;

  return useQuery({
    queryKey: [`/clients/${clientId}/orgs`],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const response = await agent.get(`/clients/${encodeURIComponent(clientId)}/orgs`);
      return response?.body?.organizations ?? [];
    },
    enabled: !!(clientId && enabled && hasAccess),
    select: (data) => [...data].sort(sortOrganizations),
    ...options,
  });
};

export default useClientOrganizations;
